import React, { useContext, useEffect, useState } from 'react'
import AddressBookUI from '@interflora/ui-components/build/components/AddressBook/AddressBook'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { DELETE_ADDRESS } from '../../graphql/queries'
import { useMutation } from '@apollo/client'
import { useRouter } from 'next/router'

const AddressBook = () => {
  const { getCustomer } = useContext(SiteContext)
  const savedAddresses = getCustomer?.data?.customer?.shippingAddresses
  const [removeAddress] = useMutation(DELETE_ADDRESS)
  const [successMessage, setSuccessMessage] = useState('')
  const router = useRouter()

  useEffect(() => {
    setSuccessMessage(router?.query?.success?.toString())
  }, [router?.query?.success])

  const removeAddressItem = async (addressId: string) => {
    setSuccessMessage('')
    try {
      await removeAddress({ variables: { input: { addressId } } })
      getCustomer?.refetch()
      setSuccessMessage('delete-address')
    } catch (error) {
      throw new Error('There was a problem removing the address, please try again.')
    }
  }

  return getCustomer?.loading || !getCustomer?.data?.customer?.id ? (
    <h1>Loading</h1>
  ) : (
    <AddressBookUI savedAddresses={savedAddresses} removeAddressItem={removeAddressItem} success={successMessage} />
  )
}

export default AddressBook
